<template lang="pug">
  DefaultLayout
    CommonSection(title="Контакты")
      template(#button)
        .buttons
          Btn(lg dark @click="$refs.list.add()")
            Icon(name="plus" pointer)
            | Добавить контакт
      ContactList(ref="list")
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';

import ContactList from '@/components/ContactList.vue';

export default {
  name: 'ContactsPage',
  components: {
    CommonSection,
    DefaultLayout,
    ContactList,
  },
  computed: {
    notifications() {
      const types = ['contact-request-created', 'contact-request-accepted', 'contact-request-declined'];
      return this.$store.state.notification.items.filter(n => types.includes(n.type));
    },
  },
  watch: {
    notifications: {
      immediate: true,
      handler(val) {
        val.forEach(n => {
          if (n.isViewed) return;
          this.$store.dispatch('notification/view', n);
        });
      },
    },
  },
};
</script>

<style scoped lang="scss">
.buttons {
  display: flex;
  gap: 30px;
}

@media (max-width: 768px) {
  .buttons {
    gap: 10px;
  }
}

@media (max-width: 576px) {
  .buttons {
    flex-direction: column;
  }
}
</style>
